/**
*** 人员管理--项目管理员界面
 */
<template>
<div id="Personage" class="jc-page">
    <div class="jc-panel jc-page-head">
        <div class="header-title">项目管理员管理</div>
        <div class="header-operation">
            <el-input style="width:200px;" v-model="organization_user_real_name" placeholder="请搜索"></el-input>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="deleteRows" type="primary">删除</el-button>
            <el-button type="primary" @click="openAddDialog">添加</el-button>
        </div>
    </div>
    <div class="jc-table-container jc-scroll-panel">
        <el-table
            ref="multipleTable"
            :data="datatable"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" prop="No"></el-table-column>
                <el-table-column label="姓名" prop="organization_user_real_name"></el-table-column>
                <el-table-column label="性别" prop="organization_user_sex">
                    <template slot-scope="scope">
                        {{scope.row.organization_user_sex == "1" ? '男':(scope.row.organization_user_sex == "0" ? '保密':'女')}}
                    </template>
                </el-table-column>
                <el-table-column label="手机号" prop="organization_user_mobile"></el-table-column>
                <el-table-column label="职务/职称" prop="organization_user_position_name"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="modifyRow(scope.row)" type="text" size="small">编辑</el-button>
                        <span>|</span>
                        <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                style="text-align:right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="count"
                layout="total, prev, pager, next"
                :total="total"
                >
            </el-pagination>
    </div>
    <el-dialog class="jc-dialog" :visible.sync="showAddDialog"
        :title="addDialogTitle" :before-close="cancelAddDialog">
        <div>
            <el-form ref="addFormRef" :model="personForm" :rules="addRulers">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员姓名" prop="organization_user_real_name">
                            <el-input v-model="personForm.organization_user_real_name" placeholder="请输入人员姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="organization_user_sex">
                            <el-select clearable v-model="personForm.organization_user_sex" placeholder="请输入性别">
                                <el-option label="保密" value="0"></el-option>
                                <el-option label="男" value="1"></el-option>
                                <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="organization_user_mobile">
                            <el-input v-model="personForm.organization_user_mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="登录名">
                            <el-input v-model="personForm.username" placeholder="请输入登录名"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="密码">
                            <el-input show-password v-model="personForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="确认密码" prop="conPassword">
                            <el-input show-password v-model="personForm.conPassword" placeholder="请输入确认密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="职务/职称">
                            <el-input v-model="personForm.organization_user_position_name" placeholder="请输入职务/职称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddDialog">取消</el-button>
            <el-button type="primary" @click="okAddDialog">确定</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {getUserList, getUserDetail, saveUserInfo, deleteUserInfo} from '@/apis/person'
export default {
   name:"Expert",
   data(){
       var validateConPassword = (rule, value, callback) => {
            if(value < this.personForm.password){
                this.$message.error('两次密码不一致');
                callback(new Error());
            } else {
                callback();
            }
        }
       return {
            addRulers:{
                conPassword: [
                    { validator: validateConPassword, trigger: 'blur' }
                ],
                organization_user_real_name: [
                    { required: true, message: '请输入人员姓名', trigger: 'blur' }
                ],
                organization_user_sex: [
                    { required: true, message: '请输入性别', trigger: 'blur' }
                ],
                organization_user_mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
            },
            organization_user_real_name:'',
            multipleSelection:[],
            currentPage:1,// 当前页数
            count:10,//表格页数d
            total:0,// 总条目数
            datatable:[],
            showAddDialog:false,
            phoneNumber:'',
            personForm:{
                organization_user_id:'0',
                organization_user_real_name:'',
                organization_user_mobile:'',
                organization_user_sex:'',
                organization_user_position_name:'',
                username:'',
                password:'',
                conPassword:''
            },
            majors:[],
            addDialogTitle:'添加项目管理员'
       }
   },
   mounted(){
       this.loadData()
       this.loadBasicData()
   },
   methods:{
        handleSelectionChange(val){
            this.multipleSelection = val
        },
        modifyRow(row){
            getUserDetail({
                "organization_user_id":row.organization_user_id
            }).then(res=>{
                this.personForm = res.data.data.organization_user_info
                this.personForm.password = ""
                this.personForm.conPassword = ""
                this.showAddDialog = true
                this.addDialogTitle = '修改项目管理员'
            })

        },
        deleteRow(row){
            this.$confirm('是否删除数据?').then(() => {
                deleteUserInfo({
                    organization_user_id_list:[row.organization_user_id]
                }).then(res=>{
                    this.loadData()
                    this.$message.success("删除成功")
                })
            })
        },
        deleteRows(){
             this.$confirm('是否删除数据?').then(() => {
                if(this.multipleSelection.length > 0){
                    let temp = []
                    this.multipleSelection.forEach(x=>{
                        temp.push(x.organization_user_id)
                    })
                    deleteUserInfo({
                        organization_user_id_list:temp
                    }).then(res=>{
                        this.loadData()
                        this.$message.success("删除成功")
                    })
                } else {
                    this.$message.error("请选择待删除数据")
                }
            })
        },
        handleSizeChange(val) {

        },
        handleCurrentChange(val) {
            this.loadData()
        },
        initFormModel(){
            this.personForm = {
                organization_user_id:'0',
                organization_user_real_name:'',
                organization_user_mobile:'',
                organization_user_sex:'',
                organization_user_position_name:'',
                username:'',
                password:'',
                conPassword:''
            }
        },
        loadBasicData(){

        },
        loadData(){
            getUserList({
                "organization_user_real_name":this.organization_user_real_name,
                "pagination":{

                    "page":this.currentPage,
                    "count":this.count
                }
            }).then(res=>{
              console.log(res)
                this.datatable = res.data.data.organization_user_list
                this.total=Number(res.data.data.paginated.total)
            })
        },
        cancelAddDialog(){
            this.showAddDialog = false
            this.initFormModel()
        },
        openAddDialog(){
             this.showAddDialog = true
             this.addDialogTitle = '添加项目管理员'
        },
        okAddDialog(){
            this.$refs.addFormRef.validate(valid=>{
                if(valid){
                    saveUserInfo({
                        ...this.personForm,
                    }).then(res=>{
                        if(res.data.status == "1"){
                            this.$message.success("添加成功")
                            this.loadData()
                            this.initFormModel()
                            this.showAddDialog = false
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            })

        },
   }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Orgin/PersonManag/ProAdministrator.vue